module.exports = __webpack_public_path__ + "static/media/group1.af531de5.svg";